import React, { useEffect } from 'react';
import propTypes from 'prop-types';
import initializePendo from './initializePendo';

export function PendoProvider({ children }) {
  useEffect(() => {
    if (window.AssignmentAppConfig.PENDO.enabled) {
      initializePendo();
    }
  }, []);
  return <>{children}</>;
}

PendoProvider.propTypes = {
  children: propTypes.node.isRequired,
};
